import React from "react";
import { useTranslation } from "react-i18next";
import TopDealsSection from "../components/TopDealsSection";

/**
 * Mobile-tab parity (native iOS has a dedicated "Top Deals" tab) —
 * gives mobile-web users a dedicated `/top-deals` route instead of
 * having to scroll the dashboard. The actual rendering is delegated
 * to `TopDealsSection`, the same component used inline on the
 * dashboard, so behaviour stays identical.
 *
 * Sprint M Item 5 — i18n Phase 2: all visible strings come from
 * the `topdeals` namespace (DE/EN/HR).
 */
export default function TopDealsPage() {
  const { t } = useTranslation("topdeals");
  return (
    <div data-testid="top-deals-page" className="space-y-6">
      <div>
        <h1 className="text-2xl text-zinc-100 font-medium tracking-tight">
          {t("page.heading")}
        </h1>
        <p className="mt-1 text-sm text-zinc-400">
          {t("page.headingSub")}
        </p>
      </div>
      <TopDealsSection hideHeader />
    </div>
  );
}
